import React, { useCallback, useEffect, useState } from 'react';
import styles from './index.module.less';
import { Select, Tooltip, message } from 'antd';
import { floderOptions } from './config';
import {
  FileType,
  SelectVal,
  SelectRoleVal,
  SecuresTypeVal,
} from '../../types';
import CardItem from '../CardItem';
import { addSecuritySettings, getSecuritySettings } from '../../api/wiki';
import { SelectRoleEnum } from '../..';

const { Option } = Select;
let result: any;
const SecuritySettings = (props: any) => {
  const { folderId } = props;
  const [downloadOptions, setDownloadOptions] = useState<any>([]);
  const [defaultDownloadValue, setDefaultDownloadValue] = useState<any>(
    undefined
  );

  useEffect(() => {
    console.log('folderId', folderId);
    const downloadOptions: any[] = floderOptions();
    console.log('downloadOptions', downloadOptions);
    setDownloadOptions(downloadOptions);
    doGetSecuritySettings(folderId);
  }, [folderId]);
  const doGetSecuritySettings = (folderId: any) => {
    getSecuritySettings(folderId, FileType.Folder)
      .then(result1 => {
        const [data, err] = result1;
        //@ts-ignore
        if (!data?.length) {
          result = data;
          const roleId = getRoleIdBySelectVal(SelectRoleEnum.FolderAll);
          console.log(roleId, 'roleId');
          setDefaultDownloadValue(roleId);
        } else {
          result = data;
          setDefaultDownloadValue(
            getRoleIdBySelectVal(Number(result[0].roleId))
          );
        }
        console.log('getSecuritySettings', data);
      })
      .catch(e => {
        //  message.error("")
        console.log('getSecuritySettingserror', e);
      });
  };
  const getRoleIdBySelectVal = (roleId: any) => {
    switch (roleId) {
      case SelectRoleVal.FolderAll:
        return SelectVal.ALL;
      case SelectRoleVal.FolderOnlyEdit:
        return SelectVal.EDIT_OWNER;
      case SelectRoleVal.FolderOnlyOwner:
        return SelectVal.OWNER;
      default:
        return SelectVal.ALL;
    }
  };

  const createDataFormat = (preData = [], selectItem: any) => {
    if (!preData.length) return [selectItem];
    selectItem.securesType = selectItem.secureType;
    let newData = preData.map((item: any) => {
      item.secureType = item.securesType;
      if (item.securesType === selectItem.securesType) {
        item.roleId = selectItem.roleId;
        item.secureType = selectItem.securesType;
      }
      delete item.bizId;
      delete item.bizType;
      delete item.securesType;
      delete item.show;
      return item;
    });
    return newData;
  };
  const doAddSecuritySettings = (list: any) => {
    addSecuritySettings(folderId, FileType.Folder, list).then(
      async (res: any) => {
        const [data, err] = res;
        if (err || !data) {
          if (!err?.['errResolved']) {
            message.error(err?.msg || '设置失败');
          }
          return;
        }

        doGetSecuritySettings(folderId);
        message.success('设置成功');
      }
    );
  };
  console.log(
    defaultDownloadValue,
    downloadOptions[0]?.value,
    defaultDownloadValue || downloadOptions[0]?.value,
    'test111'
  );
  if (!downloadOptions.length) {
    return null;
  }
  console.log(defaultDownloadValue || downloadOptions[0]?.value, 'value');
  return (
    <CardItem title="谁可以下载、导出、打印或保存为模版此文件">
      <div className={styles['security-setting-main']}>
        <Select
          className={styles['security-setting-main-select']}
          size="large"
          value={defaultDownloadValue || downloadOptions[0]?.value}
          onChange={val => {
            const item = downloadOptions.find(
              (item: any) => item.value === val
            );
            console.log(val, 'doAddSecuritySettingsval', result);
            doAddSecuritySettings(
              // @ts-ingnore
              createDataFormat(result, {
                roleId: item.roleId,
                secureType: SecuresTypeVal.Download,
              })
            );
          }}
        >
          {downloadOptions?.map((item: any, index: number) => {
            return (
              <Option key={index} value={item.value} disabled={item.disabled}>
                {item.disabled ? (
                  <Tooltip placement="topLeft" title={item.tips}>
                    <a style={{ cursor: 'not-allowed' }}>
                      <h4
                        className={styles['security-setting-main-select_name']}
                      >
                        {item.lebal}
                      </h4>
                      <p
                        className={styles['security-setting-main-select_desc']}
                      >
                        {item.desc}
                      </p>
                    </a>
                  </Tooltip>
                ) : (
                  <a>
                    <h4 className={styles['security-setting-main-select_name']}>
                      {item.lebal}
                    </h4>
                    <p className={styles['security-setting-main-select_desc']}>
                      {item.desc}
                    </p>
                  </a>
                )}
              </Option>
            );
          })}
        </Select>
      </div>
    </CardItem>
  );
};

export default SecuritySettings;
